import { useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { useTheme } from "../context/ThemeContext";
import { useAirline } from "../context/AirlineContext";
import { CarouselModal } from "../shared/CreativeCarousel";
import { resolveIcon } from "../shared/iconMap";
import { AirlineSlideHead } from "../shared/AirlineSlideRenderers";

const SlideRBACreativity = () => {
  const { isDark } = useTheme();
  const { airline } = useAirline();
  const brand = airline.brandColor || "#FFCD00";
  const c = airline?.content?.creativity || {};
  const clusters = c.clusters || [];
  const [activeId, setActiveId] = useState(null);
  const active = clusters.find((cl) => cl.id === activeId);
  const resolveColor = (col) => (col === "brand" ? brand : col);

  return (
    <div>
      <AirlineSlideHead
        eyebrow="Creativity"
        title="Market insight,"
        accentLine="premium content."
        airline={airline}
        accent={brand}
      />
      <p className={`k-lead max-w-[54ch] ${isDark ? "text-white/70" : "text-black/60"}`}>
        {c.subheading}
      </p>

      <div className={`mt-12 pt-8 border-t grid grid-cols-5 gap-4 ${isDark ? "border-white/10" : "border-black/10"}`}>
        {clusters.map((cluster) => {
          const Icon = resolveIcon(cluster.iconName);
          const color = resolveColor(cluster.color);
          return (
            <button
              type="button"
              key={cluster.id}
              onClick={() => setActiveId(cluster.id)}
              data-testid={`rba-cluster-${cluster.id}`}
              className={`text-left rounded-2xl p-5 border transition-all hover:-translate-y-0.5 flex flex-col ${
                isDark ? "bg-white/[0.03] border-white/10 hover:bg-white/[0.06]" : "bg-white border-black/10 hover:border-black/25"
              }`}
            >
              <div className="w-10 h-10 rounded-xl flex items-center justify-center mb-4" style={{ backgroundColor: `${color}22` }}>
                <Icon className="w-4 h-4" style={{ color }} />
              </div>
              <div className={`text-[17px] font-semibold tracking-tight leading-tight mb-3 ${isDark ? "text-white" : "text-[#1d1d1f]"}`}>
                {cluster.title}
              </div>
              <div className="flex flex-wrap gap-1 mb-auto">
                {cluster.tags.slice(0, 4).map((tag) => (
                  <span key={tag} className="text-[10px] px-2 py-0.5 rounded-full" style={{ backgroundColor: `${color}15`, color }}>{tag}</span>
                ))}
              </div>
              <div className="flex items-center gap-1 text-[12px] font-semibold mt-4" style={{ color }}>
                Explore <ArrowUpRight className="w-3 h-3" />
              </div>
            </button>
          );
        })}
      </div>

      {active && (
        <CarouselModal
          items={active.items}
          title={`${active.title} — ${airline.name}`}
          accentColor={resolveColor(active.color)}
          onClose={() => setActiveId(null)}
        />
      )}
    </div>
  );
};

export default SlideRBACreativity;
